import React from 'react'
import { Await } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  AtlasBodySubtitle,
  AtlasBodyTitle,
  CardComponent,
  NavigationMenuOrganism,
  PageContentAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'

import { Global } from 'utils/global'
import { useInventoryTransfer } from './InventoryTransfer.hooks'
import type { OutputOrderData } from 'types/inventory-transfer/model'
import LoaderAtom from 'components/atoms/Loader.atom'
import { useSessionData } from 'hooks/session.hook'

const InventoryTransferPage = () => {
  const { t } = useTranslation('global')
  const { actions, loaderData } = useInventoryTransfer()
  const { user, country, warehouse } = useSessionData()

  return (
    <React.Suspense fallback={<LoaderAtom>{t('loader.message')}</LoaderAtom>}>
      <Await
        resolve={loaderData.orders}
        errorElement={<p>Error loading orders data!</p>}
      >
        {(orders: OutputOrderData[]) => (
          <>
            {!user?.menuItems?.length && (
              <ToolbarMolecule
                title={t('inventory-transfer.home.title')}
                actionIcon="hamburger"
                onAction={Global.WV.openMenu}
              />
            )}

            {!!user?.menuItems?.length && (
              <NavigationMenuOrganism
                title={t('inventory-transfer.home.title')}
                country={country}
                userEmail={user.username}
                userName={user.firstName}
                version="13.0.1"
                warehouseName={warehouse?.coreDescription || 'Pruebas'}
                onLogout={actions.logout}
                menuItems={user.menuItems || []}
                isMenuOpen={false}
              />
            )}

            <PageContentAtom>
              {orders.map((order) => (
                <CardComponent
                  key={order._id}
                  onClick={() => {
                    actions.onSelectOrder(order)
                  }}
                >
                  <AtlasBodyTitle>#{order.order}</AtlasBodyTitle>
                  <AtlasBodySubtitle>
                    {t('inventory-transfer.home.skus', {
                      total: order.products.length
                    })}
                  </AtlasBodySubtitle>
                </CardComponent>
              ))}

              {!orders.length && (
                <AtlasBodySubtitle>
                  {t('receipt.no-data-title')}
                </AtlasBodySubtitle>
              )}
            </PageContentAtom>
          </>
        )}
      </Await>
    </React.Suspense>
  )
}

export default InventoryTransferPage
